<script setup lang="ts">
interface Props {
  size?: string;
  direction?: 'vertical' | 'horizontal';
  align?: 'start' | 'end' | 'center' | 'baseline' | 'stretch';
}

withDefaults(defineProps<Props>(), {
  size: '0px',
  direction: 'horizontal',
  align: 'stretch',
});
</script>

<template>
  <div
    :class="$style.wrapper"
    :style="{
      gap: size,
      flexDirection: direction === 'vertical' ? 'column' : 'row',
      alignItems: align,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.wrapper {
  display: flex;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
